import React, { useEffect, useState } from 'react'
import { Modal } from 'react-bootstrap'
import { toast } from 'react-toastify'
import { useI18n } from '../../../../Utils/_helpers/useI18n'
import { PromoAction } from '../../../../../services/cellcast.v2.types'
import {
  useAddPromoActionMutation,
  useUpdatePromoActionMutation,
} from '../../../../../services/cellcast.v2'
import Select from 'react-select'
import { IndustryOptions } from '../../../AdminPages/AllCellCastUser/Constant/CellCastConstant'

interface CreatePromoActionModalProps {
  show: boolean
  handleClose: () => void
  promoAction?: PromoAction | null
  onSuccess?: () => void
  isAdmin?: boolean
}

export const CreatePromoActionModal: React.FC<CreatePromoActionModalProps> = ({
  show,
  handleClose,
  promoAction,
  onSuccess,
  isAdmin = false,
}) => {
  const { t } = useI18n()
  const [addPromoAction] = useAddPromoActionMutation()
  const [updatePromoAction] = useUpdatePromoActionMutation()

  // Form state
  const [name, setName] = useState('')
  const [industry, setIndustry] = useState('')
  const [affiliate, setAffiliate] = useState('')

  const [color, setColor] = useState('#7bdcb5')
  const [error, setError] = useState('')

  useEffect(() => {
    if (promoAction) {
      setName(promoAction.name)
      setIndustry(promoAction.industry || '')
      setAffiliate(promoAction.affiliate || '')
      // setColor(promoAction.color)
    } else {
      setName('')
      setIndustry('')
      setAffiliate('')
      // setColor('#7bdcb5')
    }
  }, [promoAction, show])

  const handleSubmit = async () => {
    try {
      const payload = {
        name,
        industry,
        affiliate,
        // color,
        // ...(promoAction && { id: promoAction.id }),  //  Add id if we're updating
      }
      const result = promoAction
        ? await updatePromoAction({ ...payload, id: promoAction.id }).unwrap()
        : await addPromoAction(payload).unwrap()

      if (result.status) {
        toast.success(result.message)

        if (onSuccess) {
          onSuccess()
        }
      } else {
        toast.error(result.message)
      }
    } catch (error) {
      toast.error(promoAction ? t('PROMO_ACTION.EDIT.ERROR') : t('PROMO_ACTION.CREATE.ERROR'))
    }
  }

  // const handleChangeColor = (colorResult: any) => {
  //   setColor(colorResult.hex)
  // }

  const validateName = () => {
    if (name.length < 2 || name.length > 25) {
      setError(t('PROMO_ACTION.CREATE.NAME_LENGTH_ERROR'))
      return false
    }

    setError('')
    return true
  }

  return (
    <Modal
      id='kt_modal_create_promo_action'
      tabIndex={1}
      aria-hidden='true'
      dialogClassName='modal-dialog-centered mw-450px'
      show={show}
      onHide={handleClose}
    >
      <div className='modal-header'>
        <h2>
          {promoAction
            ? t('PROMO_ACTION.CREATE_MODAL.TITLE', { action: t('GENERAL.EDIT') })
            : t('PROMO_ACTION.CREATE_MODAL.TITLE', { action: t('GENERAL.CREATE') })}
        </h2>
      </div>
      <div className='modal-body p-10'>
        <div className='mb-10'>
          <label className='form-label required fw-bold fs-6'>
            {t('PROMO_ACTION.CREATE.NAME_LABEL')}
          </label>
          <input
            type='text'
            className='form-control form-control-lg form-control-solid'
            placeholder={t('PROMO_ACTION.CREATE.NAME_PLACEHOLDER')}
            value={name}
            onChange={(e) => {
              setName(e.target.value)
              if (e.target.value.length > 0) {
                setError('')
              }
            }}
            onBlur={validateName}
            maxLength={25}
          />
          {error && <div className='text-danger mt-2'>{error}</div>}
        </div>

        {isAdmin ? (
          <>
            <div className='mb-7'>
              <label className='form-label fw-bold fs-6'>
                {t('PROMO_ACTION.CREATE.INDUSTRY_LABEL')}
              </label>
              <Select
                value={IndustryOptions.find(option => option.value === industry)}
                isSearchable={false}
                name='industry'
                onChange={(e: any) => setIndustry(e.value)}
                options={IndustryOptions}
              />
            </div>
            <div className='mb-7'>
              <label className='form-label fw-bold fs-6'>
                {t('PROMO_ACTION.CREATE.AFFILIATE_LABEL')}
              </label>
               <input
                type='text'
                className='form-control form-control-lg form-control-solid'
                placeholder={t('PROMO_ACTION.CREATE.AFFILIATE_PLACEHOLDER')}
                value={affiliate}
                onChange={(e) => {
                  setAffiliate(e.target.value)
                  if (e.target.value.length > 0) {
                    setError('')
                  }
                }}
              />
            </div>
          </>
        ) : null}


        <div className='d-flex justify-content-end mt-10'>
          <button type='button' onClick={handleClose} className='btn btn-light me-3'>
            {t('GENERAL.CANCEL')}
          </button>
          <button
            type='button'
            onClick={handleSubmit}
            className='btn btn-primary'
            disabled={!name || !!error}
          >
            {promoAction ? t('GENERAL.UPDATE') : t('GENERAL.CREATE')}
          </button>
        </div>
      </div>
    </Modal>
  )
}
